<script context="module">
  import obamaFoundation from "../assets/logos/obamaFoundation.svelte";
  import obamaFoundationIcon from "../assets/logos/obamaFoundationIcon.svelte";
  import obamaPresidencialCenter from "../assets/logos/obamaPresidencialCenter.svelte";
  import democracyForum from "../assets/logos/democracyForum.svelte";
  import democracyForumCenter from "../assets/logos/democracyForumCenter.svelte";
  import futureSeries from "../assets/logos/futureSeries.svelte";
  import futureSeriesCenter from "../assets/logos/futureSeriesCenter.svelte";
  import leaders from "../assets/logos/leaders.svelte";
  import MBKAlliance from "../assets/logos/MBKAlliance.svelte";
  import obamaFoundationScholars from "../assets/logos/obamaFoundationScholars.svelte";
  import obamaFoundationDarkMode from "../assets/logos/obamaFoundationDarkMode.svelte";
  import obamaPresidencialCenterDarkMode from "../assets/logos/obamaPresidencialCenterDarkMode.svelte";
  import obamaFoundationIconDarkMode from "../assets/logos/obamaFoundationIconDarkMode.svelte";

  export const LOGO_TYPES = {
    obamaFoundation,
    obamaFoundationIcon,
    obamaPresidencialCenter,
    obamaFoundationScholars,
    democracyForum,
    democracyForumCenter,
    futureSeries,
    futureSeriesCenter,
    leaders,
    MBKAlliance,
    obamaFoundationDarkMode,
    obamaPresidencialCenterDarkMode,
    obamaFoundationIconDarkMode
  };

  function getLogoType(name) {
    return LOGO_TYPES[name];
  }
</script>

<script>
  /** @type {keyof typeof LOGO_TYPES} */
  export let type = "obamaFoundation";

  /** Primarily used for testing @type {string} */
  export let id = null;

  let logoClass = "";

  export { logoClass as class };

  if (!Object.keys(LOGO_TYPES).includes(type)) {
    // TODO swap for validateProp utils
    /* eslint-disable no-console */
    console.error(`[ICON ERROR] "${type}" is not a supported icon type.`);
  }

  $: component = getLogoType(type);
</script>

<svelte:component this={component} aria-hidden="true" class={logoClass} fill="currentColor" {id} />
